import { render, staticRenderFns } from "./editPermisos.vue?vue&type=template&id=0811e0a9&"
import script from "./editPermisos.vue?vue&type=script&lang=js&"
export * from "./editPermisos.vue?vue&type=script&lang=js&"
import style0 from "./editPermisos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports